/* AimGrips Product Page — gallery, variant picker, quantity, sticky ATC bar */
(function () {
  'use strict';

  function moneyFormat(cents) {
    /* Falls back to $X.XX — themes with custom money formats still show correct numbers */
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    /* Dawn-style cart icon bubble re-render (no-op on other themes) */
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var el = document.getElementById('cart-icon-bubble');
        if (el && data['cart-icon-bubble']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-icon-bubble'];
          var inner = tmp.querySelector('.shopify-section') || tmp.firstElementChild;
          if (inner) el.innerHTML = inner.innerHTML;
        }
      })
      .catch(function () {});
  }

  function initProduct(root) {
    if (root.dataset.agpInit === 'true') return;
    root.dataset.agpInit = 'true';

    /* ---------- Gallery ---------- */
    var medias = Array.prototype.slice.call(root.querySelectorAll('[data-agp-media]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-agp-thumb]'));

    function showMedia(id) {
      medias.forEach(function (m) {
        var active = m.getAttribute('data-agp-media') === String(id);
        m.classList.toggle('is-active', active);
        var v = m.querySelector('video');
        if (v && !active) v.pause();
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-agp-thumb') === String(id));
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-agp-thumb')); });
    });

    /* ---------- Variants ---------- */
    var variantsEl = root.querySelector('[data-agp-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = root.querySelector('form [name="id"]');
    var priceEl = root.querySelector('[data-agp-price]');
    var compareEl = root.querySelector('[data-agp-compare]');
    var stockEl = root.querySelector('[data-agp-stock]');
    var atcBtns = Array.prototype.slice.call(root.querySelectorAll('[data-agp-atc]'));
    var stickyPrice = root.querySelector('[data-agp-sticky-price]');

    function currentOptions() {
      var opts = [];
      Array.prototype.forEach.call(root.querySelectorAll('[data-agp-option]'), function (fs, i) {
        var checked = fs.querySelector('input:checked');
        opts[i] = checked ? checked.value : null;
      });
      return opts;
    }

    function applyVariant(variant) {
      if (!variant) {
        atcBtns.forEach(function (b) { b.disabled = true; b.textContent = b.getAttribute('data-text-unavailable') || 'Unavailable'; });
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = moneyFormat(variant.price);
      if (stickyPrice) stickyPrice.textContent = moneyFormat(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = moneyFormat(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      atcBtns.forEach(function (b) {
        b.disabled = !variant.available;
        b.textContent = variant.available
          ? (b.getAttribute('data-text-add') || 'Add to cart')
          : (b.getAttribute('data-text-soldout') || 'Sold out');
      });
      if (stockEl) {
        stockEl.classList.toggle('is-out', !variant.available);
        stockEl.textContent = variant.available
          ? (stockEl.getAttribute('data-text-in') || 'In stock. Ready to ship.')
          : (stockEl.getAttribute('data-text-out') || 'Sold out — back soon.');
      }
      if (variant.featured_media && variant.featured_media.id) showMedia(variant.featured_media.id);
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-agp-option] input'), function (input) {
      input.addEventListener('change', function () {
        var opts = currentOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        applyVariant(match || null);
      });
    });

    /* ---------- Quantity ---------- */
    var qtyInput = root.querySelector('[data-agp-qty]');
    Array.prototype.forEach.call(root.querySelectorAll('[data-agp-qty-change]'), function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var delta = parseInt(btn.getAttribute('data-agp-qty-change'), 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
      });
    });

    /* ---------- Grid gallery: "See all" toggle ---------- */
    Array.prototype.forEach.call(root.querySelectorAll('[data-agp-seeall]'), function (btn) {
      btn.addEventListener('click', function () {
        var grid = root.querySelector('[data-agp-gridgal]');
        if (!grid) return;
        var expanded = grid.classList.toggle('is-expanded');
        btn.textContent = expanded ? (btn.getAttribute('data-text-less') || 'Show less') : (btn.getAttribute('data-text-more') || 'See all');
        btn.setAttribute('aria-expanded', String(expanded));
      });
    });

    /* ---------- Grid gallery: lightbox (swipeable, with a short slide animation) ---------- */
    var tiles = Array.prototype.slice.call(root.querySelectorAll('button[data-agp-tile]'));
    if (tiles.length) {
      var lbIndex = 0;
      function ensureLightbox() {
        var lb = document.getElementById('agp-lightbox');
        if (lb) return lb;
        var style = document.createElement('style');
        style.textContent =
          '#agp-lightbox{position:fixed;inset:0;z-index:999;background:rgba(4,6,9,.94);display:none;align-items:center;justify-content:center;overflow:hidden}' +
          '#agp-lightbox.is-open{display:flex}' +
          '#agp-lightbox img{max-width:92vw;max-height:88vh;border-radius:12px;object-fit:contain;touch-action:pan-y;will-change:transform}' +
          '#agp-lightbox button{position:absolute;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.2);color:#fff;border-radius:50%;width:44px;height:44px;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center}' +
          '#agp-lightbox button:hover{background:rgba(34,211,238,.25)}' +
          '#agp-lightbox [data-lb-close]{top:18px;right:18px}' +
          '#agp-lightbox [data-lb-prev]{left:14px;top:50%;transform:translateY(-50%)}' +
          '#agp-lightbox [data-lb-next]{right:14px;top:50%;transform:translateY(-50%)}' +
          '@media (max-width:760px){#agp-lightbox [data-lb-prev],#agp-lightbox [data-lb-next]{display:none}}';
        document.head.appendChild(style);
        lb = document.createElement('div');
        lb.id = 'agp-lightbox';
        lb.setAttribute('role', 'dialog');
        lb.setAttribute('aria-modal', 'true');
        lb.setAttribute('aria-label', 'Image viewer');
        lb.innerHTML =
          '<img alt="">' +
          '<button type="button" data-lb-prev aria-label="Previous image">‹</button>' +
          '<button type="button" data-lb-next aria-label="Next image">›</button>' +
          '<button type="button" data-lb-close aria-label="Close">✕</button>';
        document.body.appendChild(lb);
        var img = lb.querySelector('img');
        lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
        lb.querySelector('[data-lb-close]').addEventListener('click', closeLb);
        lb.querySelector('[data-lb-prev]').addEventListener('click', function () { openLb(lbIndex - 1, -1); });
        lb.querySelector('[data-lb-next]').addEventListener('click', function () { openLb(lbIndex + 1, 1); });
        document.addEventListener('keydown', function (e) {
          if (!lb.classList.contains('is-open')) return;
          if (e.key === 'Escape') closeLb();
          if (e.key === 'ArrowLeft') openLb(lbIndex - 1, -1);
          if (e.key === 'ArrowRight') openLb(lbIndex + 1, 1);
        });
        /* Swipe between images — finger-tracking, then snap to next/prev */
        var dragX = null;
        lb.addEventListener('touchstart', function (e) { dragX = e.touches[0].clientX; img.style.transition = 'none'; }, { passive: true });
        lb.addEventListener('touchmove', function (e) {
          if (dragX === null) return;
          img.style.transform = 'translateX(' + (e.touches[0].clientX - dragX) + 'px)';
        }, { passive: true });
        lb.addEventListener('touchend', function (e) {
          if (dragX === null) return;
          var dx = e.changedTouches[0].clientX - dragX; dragX = null;
          if (tiles.length > 1 && Math.abs(dx) > 45) {
            openLb(lbIndex + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
          } else {
            img.style.transition = 'transform .2s ease';
            img.style.transform = 'translateX(0)';
          }
        }, { passive: true });
        return lb;
      }
      function applyLbImage(lb) {
        var img = lb.querySelector('img');
        img.src = tiles[lbIndex].getAttribute('data-src');
        img.alt = tiles[lbIndex].getAttribute('data-alt') || '';
      }
      function openLb(i, dir) {
        var lb = ensureLightbox();
        var img = lb.querySelector('img');
        var next = ((i % tiles.length) + tiles.length) % tiles.length;
        var animate = dir && lb.classList.contains('is-open') && next !== lbIndex && tiles.length > 1;
        lbIndex = next;
        if (animate) {
          /* slide the current image out, swap, slide the new one in from the opposite edge */
          img.style.transition = 'transform .14s ease, opacity .14s ease';
          img.style.opacity = '0';
          img.style.transform = 'translateX(' + (dir * -36) + 'px)';
          setTimeout(function () {
            applyLbImage(lb);
            img.style.transition = 'none';
            img.style.transform = 'translateX(' + (dir * 36) + 'px)';
            requestAnimationFrame(function () {
              img.style.transition = 'transform .22s cubic-bezier(.22,.61,.36,1), opacity .2s ease';
              img.style.opacity = '1';
              img.style.transform = 'translateX(0)';
            });
          }, 130);
        } else {
          applyLbImage(lb);
          img.style.transition = 'none';
          img.style.opacity = '1';
          img.style.transform = 'translateX(0)';
        }
        lb.classList.add('is-open');
        lb.querySelector('[data-lb-close]').focus();
      }
      function closeLb() {
        var lb = document.getElementById('agp-lightbox');
        if (lb) lb.classList.remove('is-open');
        if (tiles[lbIndex]) tiles[lbIndex].focus();
      }
      tiles.forEach(function (tile, i) {
        tile.addEventListener('click', function () { openLb(i); });
      });
    }

    /* ---------- Mobile swipe carousel ---------- */
    var mcar = root.querySelector('[data-agp-mcarousel]');
    if (mcar) {
      var mtrack = mcar.querySelector('[data-agp-mtrack]');
      var mslides = Array.prototype.slice.call(mcar.querySelectorAll('[data-agp-mslide]'));
      var mdots = Array.prototype.slice.call(mcar.querySelectorAll('[data-agp-mdot]'));
      var mActive = 0;

      function setMActive(i) {
        mActive = Math.max(0, Math.min(mslides.length - 1, i));
        mdots.forEach(function (d, di) { d.classList.toggle('is-active', di === mActive); });
      }

      /* Sync dots while swiping */
      if (mtrack && mslides.length > 1) {
        var mRaf;
        mtrack.addEventListener('scroll', function () {
          if (mRaf) return;
          mRaf = requestAnimationFrame(function () {
            mRaf = null;
            var step = mslides[1].offsetLeft - mslides[0].offsetLeft;
            setMActive(step > 0 ? Math.round(mtrack.scrollLeft / step) : 0);
          });
        }, { passive: true });
      }

      /* Dot click -> scroll to slide */
      mdots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          if (mtrack && mslides[i]) mtrack.scrollTo({ left: mslides[i].offsetLeft - mtrack.offsetLeft, behavior: 'smooth' });
        });
      });

      /* Open the existing lightbox by matching the grid tile with the same full-res src */
      function openMZoom(src) {
        if (!src) return;
        var match = tiles.filter(function (t) { return t.getAttribute('data-src') === src; })[0];
        if (match) { match.click(); }
        else if (tiles[0]) { tiles[0].click(); }
      }
      Array.prototype.forEach.call(mcar.querySelectorAll('[data-agp-mzoom]'), function (z) {
        z.addEventListener('click', function () { openMZoom(z.getAttribute('data-agp-mzoom')); });
      });
      var mSeeAll = mcar.querySelector('[data-agp-mseeall]');
      if (mSeeAll) {
        mSeeAll.addEventListener('click', function () {
          var zoom = mslides[mActive] && mslides[mActive].querySelector('[data-agp-mzoom]');
          openMZoom(zoom ? zoom.getAttribute('data-agp-mzoom') : null);
        });
      }
    }

    /* ---------- AJAX add to cart (stay on page) ---------- */
    var ajaxForm = root.querySelector('form[data-agp-ajax]');
    if (ajaxForm && ajaxForm.getAttribute('data-agp-ajax') === 'false') ajaxForm = null;
    if (ajaxForm && window.fetch) {
      ajaxForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = parseInt(ajaxForm.querySelector('[name="id"]').value, 10);
        var qtyEl = ajaxForm.querySelector('[name="quantity"]');
        var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
        var btns = atcBtns.filter(function (b) { return !b.disabled; });
        btns.forEach(function (b) { b.disabled = true; b.textContent = b.getAttribute('data-text-adding') || 'Adding…'; });
        var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: id, quantity: qty })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            btns.forEach(function (b) { b.textContent = b.getAttribute('data-text-added') || 'Added ✓'; });
            refreshCartUI();
            setTimeout(function () {
              btns.forEach(function (b) { b.disabled = false; b.textContent = b.getAttribute('data-text-add') || 'Add to cart'; });
            }, 2200);
          })
          .catch(function () {
            btns.forEach(function (b) { b.disabled = false; b.textContent = b.getAttribute('data-text-add') || 'Add to cart'; });
            ajaxForm.removeAttribute('data-agp-ajax');
            ajaxForm.submit(); /* full-page fallback */
          });
      });
    }

    /* ---------- Sticky ATC bar ---------- */
    var sticky = root.querySelector('[data-agp-sticky]');
    var buyArea = root.querySelector('[data-agp-buyrow]');
    if (sticky && buyArea && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      }, { threshold: 0 }).observe(buyArea);
    }
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-agp-product]'), initProduct);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
